const texxt = document.getElementById('texxt');
const seccion8 = document.getElementById('seccion8');

//console.log (texxt);

texxt.addEventListener("click", function (e8) {
    seccion8.style.display = 'block';
  });

